import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
//import globalcontext
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetAll, Delete } from '../../service/PageService';

export default function PageList() {

  const {
    setIsLoading,
    setAppError,
    setAppErrorMessage,
    setAppErrorTitle,
    setAppErrorMode,
  } = useGlobalContext();

  const [pages, setPages] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Fetch pages list with pagination
  const fetchPageList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetAll(currentPage, limit, keyword);
      setPages(response.pages || []);
      setTotalPages(response.totalPages || 1); // make sure backend returns totalPages or calculate accordingly
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  // Delete handler
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this page?");
    if (!confirmDelete) return;

    try {
      setIsLoading(true);
      const response = await Delete(id);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Page Successfully Deleted");
        setAppErrorMode("success");
        fetchPageList(page); // refresh list after deletion
      } else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to delete page. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to delete page. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  // Reset to page 1 on keyword search and fetch
  const handleSearch = () => {
    setPage(1);
    fetchPageList(1);
  };

  // Refetch when page changes
  useEffect(() => {
    fetchPageList(page);
  }, [page]);

  return (
    <>
      <Helmet>
        <title>Our Information | {config.appName} </title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Our Information</h1>
            <span>
              <Link to="/"> Dashboard </Link>  / Our Information
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='table-content'>
                  <div className="mobile-scroll">
                    <table className='table table-bordered table-condensed'>
                      <thead>
                        <tr>
                          <th>Sl.no</th>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pages.length > 0 ? (
                          pages.map((pageItem, index) => (
                            <tr key={pageItem.id}>
                              <td>{(page - 1) * limit + index + 1}</td>
                              <td>{pageItem.name}</td>
                              <td>{pageItem.status}</td>
                              <td>
                                <Link to={`/page/view/${pageItem.id}`} className='btn btn-sm btn-warning' title="View Page">
                                  <FontAwesomeIcon icon="fa-solid fa-eye" />
                                </Link>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">No pages found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
